/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinksnav2Inputs */

const en_downloadlinksnav2 = /** @type {(inputs: Downloadlinksnav2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download links`)
};

const de_downloadlinksnav2 = /** @type {(inputs: Downloadlinksnav2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download-Links`)
};

/**
* | output |
* | --- |
* | "Download links" |
*
* @param {Downloadlinksnav2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinksnav2 = /** @type {((inputs?: Downloadlinksnav2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinksnav2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinksnav2(inputs)
	return de_downloadlinksnav2(inputs)
});
export { downloadlinksnav2 as "downloadLinksNav" }